export default {"src":"/_next/static/media/apple.5cbb1f6e.svg","height":23,"width":15};